import request from 'utils/request'

export function getOptions() {
  return request({
    url: '/hrRecruitController/getJobData',
    method: 'get'
  })
}

export function getAvatarUrl() {
  return '/api' + '/resumeController/alsoYou'
}

export function addResume(data) {
  return request({
    url: '/resumeController/saveResume',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/resume.js